module Eseebase {
    export interface ILoaderOverlayScope extends ng.IScope {
        isShown: boolean;
    }

    export class LoaderOverlayDirective {
        public link: (scope: ILoaderOverlayScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => void;
        public templateUrl = '/app/directives/loader-overlay.html';
        public scope = {
            
        };
        public restrict = 'E';
        public require: string;
        public replace: any;

        constructor(private $rootScope: any) {
            LoaderOverlayDirective.prototype.replace = 'true';
            LoaderOverlayDirective.prototype.link = (scope: ILoaderOverlayScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => {
                scope.isShown = true;
                $rootScope.$on('$hideLoader', () =>
                {
                    scope.isShown = false;
                });
                $rootScope.$on('$showLoader', () => {
                    scope.isShown = true;
                });
            };
        }

        public static Factory() {
            var directive = ($rootScope: any) => {
                return new LoaderOverlayDirective($rootScope);
            };

            directive['$inject'] = ['$rootScope'];

            return directive;
        }
    }

    angular
        .module('eseebase')
        .directive('loaderOverlay', LoaderOverlayDirective.Factory());
}